import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";

export interface ICopyAssetsMutationParameters {
    srcProductId: string;
    srcVariantId: string;
    targetProductId: string;
    targetVariantId: string;
}

export const useCopyAssets = (
    invalidQueryKeys: string | string[],
): UseMutationResult<{ images: number; reels: number }, unknown, ICopyAssetsMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<{ images: number; reels: number }, unknown, ICopyAssetsMutationParameters>({
        mutationFn: async (parameters: ICopyAssetsMutationParameters) => {
            if (!auth.token) {
                throw new Error("Cannot copy assets without authorization token.");
            }

            return await api.Products.copyAssets(
                parameters.srcProductId,
                parameters.srcVariantId,
                parameters.targetProductId,
                parameters.targetVariantId,
                auth.token
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
